<template>
  <div class="cost-table">
    <div class="cost-table__head">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>集群</th>
            <th>实例数量</th>
            <th>创建时间</th>
            <th>结束时间</th>
            <th>费用</th>
            <th>状态</th>
          </tr>
        </thead>
      </table>
    </div>

    <div class="cost-table__body">
      <table>
        <tbody>
          <tr v-show="data.length" v-for="(row,index) in data" :key="index">
            <td>{{index+1}}</td>
            <td>{{row.name}}</td>
            <td>{{row.size}}</td>
            <td>{{row.create_time}}</td>
            <td>{{row.end_time}}</td>
            <td>{{row.total_cost}}</td>
            <td>{{row.status}}</td>
          </tr>
          <tr v-show="data.length">
            <td>合计</td>
            <td>{{totalData.cluster}}</td>
            <td>{{totalData.size}}</td>
            <td>--</td>
            <td>--</td>
            <td>{{totalData.cost}}元</td>
            <td>--</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CostTable",
  data() {
    return {};
  },
  props: {
    data: Array
  },
  computed: {
    totalData() {
      return {
        cluster: this.data.length,
        size: this.data.reduce((sum, current) => sum + current.size, 0),
        cost: this.data.reduce((sum, current) => sum + current.total_cost, 0)
      };
    }
  }
};
</script>

<style lang="less" scoped>
.cost-table {
  &__head,
  &__body {
    & table {
      width: 100%;
      text-align: left;
      font-size: 0.75rem;
      color: #9eabbe;
      border-collapse: collapse;

      & tr td:nth-child(1),
      & tr th:nth-child(1) {
        width: 5%;
      }

      & tr td:nth-child(2),
      & tr th:nth-child(2) {
        width: 20%;
      }
      & tr td:nth-child(3),
      & tr th:nth-child(3) {
        width: 10%;
      }
      & tr td:nth-child(4),
      & tr th:nth-child(4) {
        width: 21%;
      }
      & tr td:nth-child(5),
      & tr th:nth-child(5) {
        width: 21%;
      }
      & tr td:nth-child(6),
      & tr th:nth-child(6) {
        width: 15%;
      }
      & tr td:nth-child(7),
      & tr th:nth-child(7) {
        width: 8%;
      }
    }
  }

  &__head {
    & table thead {
      text-align: center;
      background-color: #1c2130;
      & tr {
        height: 2.5rem;
      }
    }
  }

  &__body {
    height: 7.5rem;
    overflow-y: auto;
    & table tbody {
      text-align: center;

      & tr {
        height: 2rem;
      }
    }
  }
}
</style>